<template>
    <div class="login">
        <div class="main">
            <h1>后台登录系统</h1>
                <input
                    type="text"
                    placeholder="请输入用户名"
                    v-model="phone"
                    @keydown="down_enter($event)"
                />
                <input
                    type="password"
                    placeholder="请输入密码"
                    v-model="pass"
                    @keydown="down_enter($event)"
                />
                <!-- <input
                    type="text"
                    placeholder="请输入验证码"
                    v-model="code"
                /> -->
                <input type="button" value="登录" @click="click_BigBtn" />
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            phone: "", //类型：String  必有字段  备注：无
            pass: "" //类型：String  必有字段  备注：无
        };
    },
    methods: {
        down_enter(e){
            if(e.keyCode == 13){
                this.click_BigBtn();
            }
        },
        forget() {
            this.$router.push({ name: "forget" });
        },
        register() {
            this.$router.push({ name: "register" });
        },
        click_BigBtn() {
            if (!this.phone) {
                return this.$Message.info("请输入手机号码！");
			}
			if (!this.pass) {
                return this.$Message.info("请输入密码！");
            }
            // if (!this.code) {
            //     return this.$Message.info("请输入验证码！");
            // }
            this.$post(this.$path.login, {
                username: this.phone,
                pass: this.pass
                // code: this.code
            }).then(res => {
                if (res.success) {
                    this.$router.push({ name: "home" });
                }
            });
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.login{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    font-family: 'Cabin', sans-serif !important;
	background:url('/static/banner.jpg') 0px 0px;
    display: flex;
    justify-content: center;
    align-items: center;
}
.main {
    width: 400px;
}
.main h1 {
    color: #7e8fad;
    text-align: center;
    font-size: 2.5em;
    margin: 0 0 1.5em;
}

.main input[type="text"],
.main input[type="password"] {
    outline: none;
    border: 1px solid #fff;
    background: #fed2ed;
    border-radius: 5px;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    -o-border-radius: 5px;
    -ms-border-radius: 5px;
    padding: 15px 10px;
    width: 100%;
    font-size: 1.3em;
    color: #7e8fad;
    text-align: center;
    font-family: "Syncopate", sans-serif;
}
.main input[type="password"] {
    margin: 1.5em 0;
}
.main input[type="button"] {
    outline: none;
    border: 1px solid #dba9c8;
    background: #b47c9f;
    border-radius: 5px;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    -o-border-radius: 5px;
    -ms-border-radius: 5px;
    padding: 15px 10px;
    width: 100%;
    color: #fdbfe6;
    font-size: 1.5em;
    font-family: "Syncopate", sans-serif;
    cursor: pointer;
}
.main input[type="button"]:hover {
    background: #fed2ed;
    color: #b47c9f;
    border: 1px solid #fff;
}
.footer {
    text-align: center;
    padding: 2em 0 0;
}
.footer p {
    font-size: 1em;
    color: #b47c9f;
    margin: 0;
}
.footer p a {
    color: #fff;
}
.footer p a:hover {
    color: #b47c9f;
}

</style>



// WEBPACK FOOTER //
// src/components/login.vue